module.exports = "'data:image/svg+xml;utf8,<svg width=\"13\" height=\"8\" viewBox=\"0 0 13 8\" xmlns=\"http://www.w3.org/2000/svg\"><title>Slice 1</title><path d=\"M6.51 4.695l3.98-3.98a1.128 1.128 0 0 1 1.589.003c.442.442.44 1.15.002 1.588L7.303 7.084a1.118 1.118 0 0 1-.79.326 1.104 1.104 0 0 1-.796-.326L.94 2.306A1.128 1.128 0 0 1 .942.718 1.12 1.12 0 0 1 2.53.715l3.98 3.98z\" fill=\"%2349B7FF\" fill-rule=\"evenodd\"/></svg>'"


//////////////////
// WEBPACK FOOTER
// ./src/Components/Toggle/arrowExpanded.svg
// module id = 632
// module chunks = 0